import asyncActions from '../actions/asyncActions';
import { cachedRequestAction, rejectedRequestAction } from '../actions/request';
import { CACHE_ERROR } from './requestCache';

const asyncActionTypes = asyncActions.map(a => a.toString());

const requestsChecker = store => next => (action) => {
  if (asyncActionTypes.some(d => d === action.type) && action.meta && action.meta.id) {
    // this is an asynchronous action, the ID should have been stored!
    const state = store.getState();
    const { pending } = state.requests;
    if (!pending[action.meta.id]) {
      // if not found in pending requests, ignore the action
      if (action.payload && action.payload.message === CACHE_ERROR) {
        return next(cachedRequestAction(action.meta));
      }
      // Only logging this message for requests not cancelled by cache.
      return next(rejectedRequestAction(action.meta));
    }
  }
  return next(action);
};

export default requestsChecker;
